<div fxLayout="row" fxLayoutGap="16px">
  <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
  <mat-checkbox
    color="accent"
    [formControl]="control"
    [labelPosition]="labelPosition"
    (change)="onChange($event)"
    [checked]="isChecked"
  >
    {{ label }}
  </mat-checkbox>
</div>
<mat-error><wai-form-error [formField]="control"></wai-form-error></mat-error>
